import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from 'date-fns';

interface ExportOptions {
    title: string;
    filename: string;
    columns: string[];
    data: any[][];
    orientation?: 'portrait' | 'landscape';
}

export const pdfService = {
    generatePDF: ({ title, filename, columns, data, orientation = 'portrait' }: ExportOptions) => {
        const doc = new jsPDF({
            orientation: orientation,
            unit: 'mm',
            format: 'a4',
        });

        // Add Title
        doc.setFontSize(20);
        doc.setTextColor(40, 40, 40);
        doc.text(title, 14, 22);

        // Add Date
        doc.setFontSize(10);
        doc.setTextColor(100, 100, 100);
        doc.text(`Generated on: ${format(new Date(), 'PPpp')}`, 14, 28);

        // Add Table
        autoTable(doc, {
            head: [columns],
            body: data,
            startY: 35,
            theme: 'grid',
            headStyles: {
                fillColor: [15, 23, 42], // sapphire-900
                textColor: [255, 255, 255],
                fontStyle: 'bold',
            },
            styles: {
                fontSize: 10,
                cellPadding: 3,
            },
            alternateRowStyles: {
                fillColor: [248, 250, 252],
            },
        });

        // Save PDF
        doc.save(`${filename}.pdf`);
    },
};
